import { useContext } from 'react'

import { ProfileWidgetsHideContext } from '../../../../context'

export function useProfileWidgetsHideContext() {
  return useContext(ProfileWidgetsHideContext)
}
